import { render, staticRenderFns } from "./MarkupNew.vue?vue&type=template&id=05527d32&"
import script from "./MarkupNew.vue?vue&type=script&lang=js&"
export * from "./MarkupNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports